import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StylePointCard = styled.div`
  padding: 10px;
  border-radius: 10px;
  background: ${theme.colors.white};
  box-shadow: ${theme.colors.boxShadow};
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 10px;
`

export const StylePointText = styled.p`
  color: ${theme.colors.text};
  transform: translateY(-2px);
`

export const StyledFormRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`

export const LeftColumn = styled.div`
  flex: 2;
  min-width: 300px;

  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
`

export const RightColumn = styled.div`
  flex: 1;
  min-width: 200px;

  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
`

export const AddedPointsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`
